/* eslint-disable no-console */
import { CommonModule } from '@angular/common';
import { Component, OnInit, signal } from '@angular/core';
import { ProjectIdentificationDataComponent } from '../components/project-identification-data/project-identification-data.component';
import { ProjectFunctionalDataComponent } from '../components/project-functional-data/project-functional-data.component';
import { ProjectEconomicDataComponent } from '../components/project-economic-data/project-economic-data.component';
import { ProjectInputDataComponent } from '../components/project-input-data/project-input-data.component';
import { ProjectRiskDataComponent } from '../components/project-risk-data/project-risk-data.component';
import { ButtonsComponent } from '@/app/shared/buttons/buttons.component';
import { ProjectsService } from '@/app/services/ia-services/projects.service';
import { ConfirmationService } from 'primeng/api';
import { Location } from '@angular/common';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ActivatedRoute, Router } from '@angular/router';
import { ReviewFieldsService } from '@/app/services/ia-services/review-fields.service';
import { FormsModule } from '@angular/forms';
import { ProjectDetails } from '@/app/interfaces/project';
import {
  StoredUserData,
  WorkflowBackendRole,
  WorkflowFrontendRole,
  workflowRoleMap,
} from '@/app/interfaces/projects-list';
import {
  ReviewComment,
  ReviewCommentsBlockComponent,
} from '@/app/shared/review-comments-block/review-comments-block.component';

@Component({
  selector: 'app-project-review',
  standalone: true,
  imports: [
    CommonModule,
    ProjectIdentificationDataComponent,
    ProjectFunctionalDataComponent,
    ProjectEconomicDataComponent,
    ProjectInputDataComponent,
    ProjectRiskDataComponent,
    ButtonsComponent,
    ConfirmDialogModule,
    FormsModule,
    ReviewCommentsBlockComponent,
  ],
  providers: [ConfirmationService],
  templateUrl: './project-review.component.html',
  styleUrl: './project-review.component.scss',
})
export class ProjectReviewComponent implements OnInit {
  constructor(
    private projectsService: ProjectsService,
    private reviewFields: ReviewFieldsService,
    private confirmationService: ConfirmationService,
    private location: Location,
    private route: ActivatedRoute,
    private router: Router
  ) {}
  userRoles: WorkflowFrontendRole[] = [];
  userData!: StoredUserData;
  orgCode!: string;
  project: ProjectDetails | null = null;
  id_project!: string;
  selectedState: 'CORRECTION' | 'APPROVED' | 'REJECTED' | null = null;
  reviewComment = '';
  readonlyReview = false;
  payload = signal({
    userRole: '',
    state: null,
    idProyecto: '',
    nombreProyecto: '',
    comentario: '',
    camposSeleccionados: [],
  });
  dataResponse: ProjectDetails | null = null;
  reviewComments: ReviewComment[] = [];
  async ngOnInit() {
    this.userData = JSON.parse(localStorage.getItem('userData')!) as StoredUserData;
    this.id_project = this.route.snapshot.paramMap.get('id')!;
    const { data } = await this.projectsService.getProjectById(this.id_project, '', 'project');

    this.userRoles = this.getUserWorkflowRolesForProject(data);
    const activeUserRole = this.getActiveReviewRole(data);
    const roleForDetail = activeUserRole ? workflowRoleMap[activeUserRole] : '';
    const { data: finalData } = await this.projectsService.getProjectById(this.id_project, roleForDetail, 'project');

    console.log('ORG CODE PROYECTO:', this.orgCode);
    console.log('ROLES userData):', this.userData.roles);
    console.log('ROL FILTRADO:', this.userRoles);
    this.dataResponse = finalData;
    this.project = finalData;
    this.reviewFields.loadPreviousReviewsFromBackend(this.dataResponse);
    if (!this.project.eipd || this.project.eipd === 'No realizada') {
      this.reviewFields.markField('csvEipd', false);
    }
    this.readonlyReview = this.shouldOpenAsReadonlyReview();
    if (this.isProjectCorrectionState() && !this.isCurrentReviewRegistered()) {
      this.router.navigate(['/catalogo-ia/proyectos/detalles', this.id_project]);
      return;
    }

    if (roleForDetail === 'GA' && this.readonlyReview) {
      this.reviewComments = [
        {
          userRole: 'GA',
          comment: this.dataResponse.commentSupportGroup ?? null,
          state: this.dataResponse.supportGroupState ?? null,
        },
      ];
      return;
    }

    this.reviewComments = [
      {
        userRole: 'GA',
        comment: this.dataResponse.commentSupportGroup ?? null,
        state: this.dataResponse.supportGroupState ?? null,
      },
      {
        userRole: 'RF',
        comment: this.dataResponse.commentRevisorFuncional ?? null,
        state: this.dataResponse.functionalReviewerState ?? null,
      },
      {
        userRole: 'RJ',
        comment: this.dataResponse.commentRevisorJuridico ?? null,
        state: this.dataResponse.legalReviewerState ?? null,
      },
      {
        userRole: 'RT',
        comment: this.dataResponse.commentRevisorTecnico ?? null,
        state: this.dataResponse.technicalReviewerState ?? null,
      },
      {
        userRole: 'RDPD',
        comment: this.dataResponse.commentRevisorDpd ?? null,
        state: this.dataResponse.dpdReviewerState ?? null,
      },
    ];
    if (this.shouldIncludeServiceManagerComment()) {
      this.reviewComments.push({
        userRole: 'JS',
        comment: this.dataResponse.commentServiceManager ?? null,
        state: this.dataResponse.serviceManagerState ?? null,
      });
    }
  }

  backPage(): void {
    this.location.back();
  }
  async onSave() {
    const activeUserRole = this.dataResponse ? this.getActiveReviewRole(this.dataResponse) : undefined;
    const backendRole = activeUserRole ? workflowRoleMap[activeUserRole] : '';

    this.payload.update(() => ({
      userRole: backendRole,
      state: this.selectedState,
      idProyecto: this.id_project,
      nombreProyecto: this.project?.projectName ?? '',
      comentario: this.reviewComment,
      camposSeleccionados: this.reviewFields.mapMarkedFieldsToBackend(),
    }));
    await this.projectsService.changeProjectState(this.payload());
    this.router.navigate(['/catalogo-ia/proyectos/listado-proyectos']);
  }

  confirm(state: 'CORRECTION' | 'APPROVED' | 'REJECTED') {
    if (this.readonlyReview) {
      return;
    }

    if (state === 'APPROVED' && this.isChief() && this.reviewFields.mapMarkedFieldsToBackend().length > 0) {
      return;
    }

    this.selectedState = state;

    this.confirmationService.confirm({
      message: '¿Seguro que desea finalizar revisión?',
      header: 'Confirmación',
      closable: true,
      closeOnEscape: true,
      icon: 'pi pi-exclamation-triangle',
      rejectButtonProps: {
        label: 'Cancelar',
        severity: 'secondary',
        outlined: true,
      },
      acceptButtonProps: {
        label: 'Guardar',
      },
      accept: () => {
        this.onSave();
      },
    });
  }
  private mapUserRoleToBackend(userRole: string): string {
    switch (userRole) {
      case 'apoyo_OGIA':
        return 'GA'; // Grupo de Apoyo

      case 'funcional_OGIA':
        return 'RF'; // Revisor Funcional

      case 'juridico_OGIA':
        return 'RJ'; // Revisor Jurídico

      case 'dpd_OGIA':
        return 'RDPD'; // Revisor Protección de Datos

      case 'tecnico_OGIA':
        return 'RT'; // Revisor Técnico

      case 'jefe_servicio_OGIA':
        return 'JS'; // Jefe de Servicio

      default:
        return '';
    }
  }
  private getCurrentReviewState(): string {
    const activeUserRole = this.dataResponse ? this.getActiveReviewRole(this.dataResponse) : undefined;
    const backendRole = activeUserRole ? workflowRoleMap[activeUserRole] : undefined;
    const stateByRole: Record<WorkflowBackendRole, string | null | undefined> = {
      GA: this.dataResponse?.supportGroupState,
      RF: this.dataResponse?.functionalReviewerState,
      RJ: this.dataResponse?.legalReviewerState,
      RT: this.dataResponse?.technicalReviewerState,
      RDPD: this.dataResponse?.dpdReviewerState,
      JS: this.dataResponse?.serviceManagerState,
    };

    return backendRole ? (stateByRole[backendRole] ?? '').toUpperCase() : '';
  }
  isCurrentReviewRegistered(): boolean {
    const currentState = this.getCurrentReviewState();

    return currentState === 'APPROVED' || currentState === 'CORRECTION';
  }
  private shouldOpenAsReadonlyReview(): boolean {
    if (!this.isCurrentReviewRegistered()) {
      return false;
    }

    return !this.isChief() || this.isProjectCorrectionState();
  }
  private isProjectCorrectionState(): boolean {
    return this.dataResponse?.state?.toUpperCase() === 'CORRECTION';
  }
  private shouldIncludeServiceManagerComment(): boolean {
    return this.isChief() || (this.readonlyReview && this.isProjectCorrectionState());
  }
  shouldShowPreviousReviewIndicators(): boolean {
    if (this.readonlyReview && this.isProjectCorrectionState()) {
      return true;
    }

    if (!this.isChief()) {
      return false;
    }

    return !this.readonlyReview;
  }
  isSupportGroup(): boolean {
    return this.userRoles.includes('apoyo_OGIA');
  }
  isChief(): boolean {
    return this.userRoles.includes('jefe_servicio_OGIA');
  }

  protected hasMarkedFields(): boolean {
    return this.reviewFields.mapMarkedFieldsToBackend().length > 0;
  }

  private getUserWorkflowRolesForProject(project: ProjectDetails): WorkflowFrontendRole[] {
    const projectOrgs = [project.codigo_organismo, project.orgCodeCreator].filter((org): org is string => !!org);

    return Object.entries(this.userData.roles ?? {})
      .filter(([, orgs]) => {
        return (
          Array.isArray(orgs) &&
          orgs.some((userOrg) => projectOrgs.some((projectOrg) => this.isSameOrgCode(userOrg, projectOrg)))
        );
      })
      .map(([roleKey]) => roleKey)
      .filter((roleKey): roleKey is WorkflowFrontendRole => this.isWorkflowRole(roleKey));
  }

  private getActiveReviewRole(project: ProjectDetails): WorkflowFrontendRole | undefined {
    const pendingRole = this.findPendingWorkflowRole(project);

    return pendingRole ?? this.findRoleByStates(project, ['APPROVED', 'CORRECTION']);
  }

  private findPendingWorkflowRole(project: ProjectDetails): WorkflowFrontendRole | undefined {
    if (this.normalizeReviewState(project.supportGroupState) === 'PENDING') {
      return this.userRoles.includes('apoyo_OGIA') ? 'apoyo_OGIA' : undefined;
    }

    const reviewerRole = this.findReviewerRoleByStates(project, ['PENDING']);

    if (reviewerRole) {
      return reviewerRole;
    }

    if (this.normalizeReviewState(project.serviceManagerState) === 'PENDING') {
      return this.userRoles.includes('jefe_servicio_OGIA') ? 'jefe_servicio_OGIA' : undefined;
    }

    return undefined;
  }

  private findReviewerRoleByStates(project: ProjectDetails, states: string[]): WorkflowFrontendRole | undefined {
    const reviewerStateByRole: Partial<Record<WorkflowFrontendRole, string | null | undefined>> = {
      funcional_OGIA: project.functionalReviewerState,
      juridico_OGIA: project.legalReviewerState,
      tecnico_OGIA: project.technicalReviewerState,
      dpd_OGIA: project.dpdReviewerState,
    };

    return this.userRoles.find((role) => states.includes(this.normalizeReviewState(reviewerStateByRole[role])));
  }

  private findRoleByStates(project: ProjectDetails, states: string[]): WorkflowFrontendRole | undefined {
    const stateByRole: Record<WorkflowFrontendRole, string | null | undefined> = {
      apoyo_OGIA: project.supportGroupState,
      funcional_OGIA: project.functionalReviewerState,
      juridico_OGIA: project.legalReviewerState,
      tecnico_OGIA: project.technicalReviewerState,
      dpd_OGIA: project.dpdReviewerState,
      jefe_servicio_OGIA: project.serviceManagerState,
    };

    return this.userRoles.find((role) => states.includes((stateByRole[role] ?? 'PENDING').toUpperCase()));
  }

  private normalizeReviewState(state?: string | null): string {
    return (state ?? 'PENDING').toUpperCase();
  }

  private isWorkflowRole(role: string): role is WorkflowFrontendRole {
    return role in workflowRoleMap;
  }

  private normalizeOrgCode(orgCode: string): string {
    const normalizedOrgCode = orgCode.match(/ORG\d+$/);

    return normalizedOrgCode ? normalizedOrgCode[0] : orgCode;
  }

  private isSameOrgCode(leftOrgCode: string, rightOrgCode: string): boolean {
    return this.normalizeOrgCode(leftOrgCode) === this.normalizeOrgCode(rightOrgCode);
  }
}
